<template>
	<div class="height-100dvh mob-relative">
		<NcdTopContainer />
		<main
			:class="showFilter ? 'card-blur' : ''"
			class="become-panel-container mob-w100"
		>
			<div class="fs-18 fw-LM fam-lato text-black hideinlaptop">
				Panel Dashboard
			</div>
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				Panel Dashboard
			</div>

			<section
				class="app-bottom-padding"
				:class="isLaptop ? 'paneldash-main-container' : 'scroll-main-container'"
			>
				<div class="suspended-card my-2" v-if="userInfo.isPanelSuspended">
					<section
						class="d-flex justify-content-between mobgap3"
						:class="{ 'align-items-center': isLaptop }"
					>
						<div
							class="d-flex mobflex-col mobgap1"
							:class="{ 'align-items-center': isLaptop }"
						>
							<div class="fs-14 fw-800 text-red fam-lato let-spac12">
								{{
									shouldShowAppealOption()
										? "SUSPENDED"
										: ticketHistory.refernceObject.panelistNotRevoked
										? "REVOKE REQUEST REJECTED"
										: "REVOKE REQUEST SUBMITTED"
								}}
							</div>
							<div class="suspend-line mx-2" id="hideinmobile"></div>
							<div class="text-darkgrey fs-16 fam-lato fw-B">
								{{
									shouldShowAppealOption()
										? "You have been suspended for 7 days for frequently cancelling interviews."
										: ticketHistory.refernceObject.panelistNotRevoked
										? "Your request has been rejected, and your account will remain suspended for 7 days"
										: "Your revoke request has been submitted. We will get back to you shortly."
								}}
							</div>
						</div>
						<div
							class="d-flex align-items-center gap-2 pointer align-items-unset-mob"
						>
							<!--  -->
							<b-button
								id="hideinmobile"
								class="candash-addBtn"
								v-if="shouldShowAppealOption()"
								@click="showRevokeRequest = true"
								>Request Re-activation</b-button
							>
							<img
								class="arrow-icon mobrotate0"
								:class="suspendCollapse ? 'rotated-270' : 'rotated-90'"
								@click="openSuspendedDetails"
								src="../../assets/newdesign/myprofile/roundRightArrow.svg"
								alt=""
							/>
						</div>
					</section>
					<div id="hideinlaptop" class="w-100 mt-3">
						<b-button
							v-if="shouldShowAppealOption()"
							class="candash-addBtn w-100"
							@click="showRevokeRequest = true"
							>Request Re-activation</b-button
						>
					</div>
					<b-collapse v-model="suspendCollapse" v-if="isLaptop">
						<hr class="hr-background" />
						<div class="pd-table">
							<div class="blue-bar"></div>
							<div class="pd-overflow">
								<div
									class="pd-row"
									v-for="(ticket, index) in ticketHistory.refernceObject
										.lastFiveCancelled"
									:key="index"
								>
									<div class="one">
										<div class="fam-mont fw-400 fs-13 text-primary">
											Interview ID:
										</div>
										<div class="fam-lato fw-500 fs-15 text-blue mt-1">
											{{ ticket.interviewRequestID }}
										</div>
									</div>
									<div class="two">
										<div class="fam-mont fw-400 fs-13 text-primary">
											Interview Date & Time:
										</div>
										<div class="fam-lato fw-500 fs-15 text-blue mt-1">
											{{ formatDate(ticket.slot) }}
											<!-- 12.10.2024, 10:10 PM -->
										</div>
									</div>
									<div class="three">
										<div class="fam-mont fw-400 fs-13 text-primary">
											Job Name:
										</div>
										<div class="fam-lato fw-500 fs-15 text-blue mt-1">
											{{ ticket.jobInfo.title }}
										</div>
									</div>
									<div class="four">
										<div class="fam-mont fw-400 fs-13 text-primary">
											Recruiter Name:
										</div>
										<div class="fam-lato fw-500 fs-15 text-blue mt-1">
											{{ ticket.LeadRecruiterName || "N/A" }}
										</div>
									</div>
									<div class="five">
										<img
											@click="showTicketDetails(ticket)"
											class="arrow-icon-2 pointer"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-between align-items-start mt-3">
							<div>
								<div class="fam-mont fw-400 fs-13 text-primary">Reason:</div>
								<div class="fam-lato fw-R fs-15 text-darkgrey mt-1">
									{{
										ticketHistory.activity[ticketHistory.activity.length - 1]
											.title
									}}
								</div>
							</div>

							<div
								@click="showTicketHistoryModal = true"
								class="font-mont fw-600 fs-14 color-mainblue text-underline d-flex align-items-center gap-1 pointer"
							>
								<img src="@/assets/paneldashboard/show-history.svg" alt="" />
								Show Ticket History
							</div>
						</div>

						<div class="fam-mont fw-400 fs-13 text-primary mt-3">Remarks:</div>
						<div class="fam-lato fw-R fs-15 text-darkgrey mt-1">
							{{
								ticketHistory.activity[ticketHistory.activity.length - 1]
									.remarks
							}}
						</div>
						<div class="mt-3 d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center gap-2">
								<img src="@/assets/paneldashboard/remarks-dp.svg" alt="" />
								<span class="font-lato fw-600 fs-14 color-black">
									{{
										ticketHistory.activity[ticketHistory.activity.length - 1]
											.activityByName
											? ticketHistory.activity[
													ticketHistory.activity.length - 1
											  ].activityByName
											: "N/A"
									}}
								</span>
							</div>
							<div class="font-mont fs-13 fw-400 color-696969">
								{{
									ticketHistory.activity[ticketHistory.activity.length - 1]
										.activityAt
								}}
							</div>
						</div>
					</b-collapse>
				</div>

				<section
					v-if="
						panelInformation.skills.length != 0 &&
						panelInformation.experienceLevel
					"
					class="pd-top-container d-flex justify-content-between w-100 mobflex-col"
				>
					<div
						class="d-flex"
						:class="
							isLaptop ? ' align-items-start gap-2' : 'flex-wrap flex-column'
						"
					>
						<div class="d-flex align-items-center mobmb-2">
							<img src="@/assets/paneldashboard/skills.svg" alt />
							<div
								:class="isLaptop ? 'fs-16' : 'fs-14'"
								class="fam-lato fw-M text-black ml-2 white-space-no-wrap"
							>
								Skills & Exp Level :
							</div>
						</div>
						<!-- for the bwlow for loop based on conditions do bind the images its in assets/paneldashboard folder if not clear contact CB -->
						<div
							:class="isLaptop ? 'mt-1' : 'flex-wrap w-100 mobgap-2'"
							class="d-flex align-items-center flex-wrap gap-2"
						>
							<div v-for="(skill, index) in panelSkills" :key="skill + index">
								<!--  -->
								<div
									class="panel-skilltags fs-14 fw-M fam-mont text-blue d-flex align-items-center mobml-0"
								>
									<template v-if="getSkillSrc(skill.skillName)">
										<img :src="getSkillSrc(skill.skillName)" alt class="mr-1" />
									</template>
									<div v-else class="common-sm-profile-icon skill-common-icon">
										<b-avatar
											:text="skill.skillName[0].toUpperCase()"
										></b-avatar>
									</div>
									{{ skill.skillName }}<span class="line-height ml-2"> | </span
									><span class="text-experience ml-1">
										{{ skill.experienceFrom }} -
										{{ skill.experienceTo }} Yrs</span
									>
								</div>
							</div>
							<b-button
								v-if="panelInformation.skills.length > 5"
								@click="setPanelSkills()"
								class="candash-cancelBtn-js pd-btn-height"
								><span class="text-underline">
									{{
										showMore
											? "Show less"
											: `+${panelInformation.skills.length - 5} more`
									}}</span
								></b-button
							>
						</div>
					</div>
					<!-- <div class="mob-w100 mob-mt-3">
						<div class="d-flex align-items-center mob-justify-between mob-w100">
							<div class="d-flex align-items-center">
								<img src="@/assets/paneldashboard/explevel.svg" alt />
								<div class="fam-lato fw-LM fs-16 text-black ml-2">
									Experience Level
								</div>
							</div>
							<div
								class="panel-skilltags fs-14 fw-M fam-mont text-blue ml-2 mobml-0"
							>
								{{ formattedData(panelInformation.experienceLevel) }} Years
							</div>
						</div>
					</div> -->
				</section>
				<section class="d-flex w-100 mt-3 mobflex-col">
					<section class="pd-top-container w-50 mob-w100">
						<div class="d-flex align-items-center justify-content-between">
							<span class="fs-16 fw-M text-black fam-lato">Earnings</span>

							<span
								v-if="
									earningGraphData.length != 0 &&
									interviewData &&
									interviewData.totalEarning.earnings
								"
								class="fs-14 fw-LM mobfs-12 text-grey fam-mont"
							>
								<img
									class="mt-2"
									src="@/assets/newdesign/myprofile/streaksVariant.svg"
									alt=""
							/></span>
							<span
								v-if="
									interviewData &&
									!interviewData.totalEarning.earnings &&
									!graphLoader
								"
								@click="goToPayment()"
								class="fs-14 fw-LM mobfs-12 text-blue fam-mont pointer"
							>
								Setup Payment Gateway
								<img src="@/assets/paneldashboard/arrow.svg" class="ml-1" alt />
							</span>
							<span v-if="graphLoader" class="fs-14 fw-LM mobfs-12 fam-mont">
								<b-skeleton height="20px" width="100px"></b-skeleton>
							</span>
						</div>
						<hr style="border-top: 1px solid #dddddd" class="my-2" />
						<div class="d-flex mobflex-col w-100 mt-1 p-1">
							<div class="w-40 mt-2 mob-dflex mob-w100 mob-justify-between">
								<div>
									<img src="@/assets/paneldashboard/earnings.svg" alt />
									<div
										class="fam-lato fw-LM fs-16 mobfs-14 text-darkgrey my-2 mob-my0"
									>
										Total Earnings
									</div>
									<div class="mobfs-18 fs-20 text-darkgrey fw-M fam-lato">
										₹
										{{
											interviewData ? interviewData.totalEarning.earnings : "00"
										}}
										<img
											@click="goToTransaction()"
											src="@/assets/paneldashboard/expand.svg"
											class="ml-1 mt-n1 pointer"
											alt
										/>
									</div>
								</div>
								<div>
									<div class="mt-2 mb-1 fam-lato fw-LM fs-14 color-727272">
										<!-- bind class "color-038E00" for green color -->
										<!-- image name is "green-increase" -->
										<!-- color-DC143C for red color and image name is "decrease" images are in assets/paneldashboard -->
										<img
											v-if="
												interviewData &&
												interviewData.totalEarning.percentDiff.isIncreased
											"
											src="@/assets/paneldashboard/green-increase.svg"
											class="mr-1"
											alt
										/>
										<img
											v-else-if="
												interviewData &&
												!interviewData.totalEarning.percentDiff.isIncreased &&
												interviewData.totalEarning.percentDiff.percentageChange
											"
											src="@/assets/paneldashboard/decrease.svg"
											class="mr-1"
											alt
										/>
										<img
											v-else
											src="@/assets/paneldashboard/increase.svg"
											class="mr-1"
											alt
										/>
										<span
											:class="
												interviewData &&
												interviewData.totalEarning.percentDiff.isIncreased
													? 'color-038E00'
													: interviewData &&
													  !interviewData.totalEarning.percentDiff
															.isIncreased &&
													  interviewData.totalEarning.percentDiff
															.percentageChange
													? 'color-DC143C'
													: ''
											"
										>
											{{
												interviewData &&
												interviewData.totalEarning.percentDiff.isIncreased &&
												interviewData.totalEarning.percentDiff.percentageChange
													? interviewData.totalEarning.percentDiff
															.percentageChange + "% Increase"
													: interviewData &&
													  !interviewData.totalEarning.percentDiff
															.isIncreased &&
													  interviewData.totalEarning.percentDiff
															.percentageChange
													? interviewData.totalEarning.percentDiff
															.percentageChange + "% Decrease"
													: "-- Increase"
											}}
										</span>
									</div>
									<div
										class="fs-12 fam-mont fw-R text-lightgrey font-style-italic"
									>
										*Compared to Last Month
									</div>
								</div>
							</div>

							<div
								v-if="graphLoader"
								class="d-flex mob-justify-center justify-content-center mob-w100 mob-mt-3 w-60 gap-2"
							>
								<div class="w-45">
									<b-skeleton class="mt-2 w-100 h-10px"></b-skeleton>
									<b-skeleton class="mt-2 w-100 earn-loader"></b-skeleton>
								</div>
								<div class="w-45">
									<b-skeleton class="mt-2 w-100 h-10px"></b-skeleton>
									<b-skeleton class="mt-2 w-100 earn-loader"></b-skeleton>
								</div>
							</div>
							<div
								v-else
								class="d-flex mob-justify-center mob-w100 justify-content-end mob-w100 mob-mt-3 w-60"
							>
								<template
									v-if="!interviewData || !interviewData.totalEarning.earnings"
								>
									<img
										src="@/assets/paneldashboard/leftimage.svg"
										alt=""
										v-if="isLaptop"
									/>
									<img
										src="@/assets/paneldashboard/mobleftimage.svg"
										alt=""
										v-else
									/>
								</template>
								<div v-else class="w-100 mob-w100" id="heatmap2"></div>
							</div>
						</div>
					</section>

					<section
						v-if="!userInfo.isPanelSuspended"
						class="w-50 mob-w100 mob-mt-3 mobml-0 ml-3"
					>
						<div :class="!slotData && 'rotating-border'">
							<section class="pd-top-container">
								<div class="d-flex justify-content-between">
									<span class="fs-16 fw-M text-black fam-lato">Interviews</span>
									<span
										@click="showSlotModal = true"
										class="fs-14 mobfs-14 fw-LM mob-fw-600 text-blue fam-mont pointer d-flex align-items-center"
									>
										Slot Preference
										<img
											src="@/assets/paneldashboard/arrow.svg"
											class="ml-1"
											alt
										/>
									</span>
								</div>
								<hr style="border-top: 1px solid #dddddd" class="my-2" />
								<div class="d-flex mobflex-col w-100 mt-1 p-1 pb-3">
									<div class="w-50 mt-2 mob-dflex mob-w100 mob-justify-between">
										<div>
											<img src="@/assets/paneldashboard/interviews.svg" alt />
											<div
												class="fam-lato fw-LM fs-16 text-darkgrey my-2 mob-my0"
											>
												Total Interviews
											</div>
											<div class="fs-20 text-darkgrey fw-M fam-lato">
												{{
													interviewStats
														? interviewStats.PanelinterviewsTaken
																.interviewsTakenByPanel
														: "00"
												}}
											</div>
										</div>
										<div>
											<div class="mt-2 mb-1 fam-lato fw-LM fs-14 color-727272">
												<img
													v-if="
														interviewStats &&
														interviewStats.PanelinterviewsTaken.textToBeShown.endsWith(
															'Increase'
														)
													"
													src="@/assets/paneldashboard/green-increase.svg"
													class="mr-1"
													alt
												/>
												<img
													v-else-if="
														interviewStats &&
														interviewStats.PanelinterviewsTaken.textToBeShown.endsWith(
															'Decrease'
														)
													"
													src="@/assets/paneldashboard/decrease.svg"
													class="mr-1"
													alt
												/>
												<img
													v-else
													src="@/assets/paneldashboard/increase.svg"
													class="mr-1"
													alt
												/>
												<span
													:class="
														interviewStats &&
														interviewStats.PanelinterviewsTaken.textToBeShown.endsWith(
															'Increase'
														)
															? 'color-038E00'
															: interviewStats &&
															  interviewStats.PanelinterviewsTaken.textToBeShown.endsWith(
																	'Decrease'
															  )
															? 'color-DC143C'
															: ''
													"
												>
													{{
														interviewStats
															? interviewStats.PanelinterviewsTaken
																	.textToBeShown
															: "-- Increase"
													}}
												</span>
											</div>
											<div
												class="fs-12 fam-mont fw-R text-lightgrey font-style-italic"
											>
												*Compared to Last Month
											</div>
										</div>
									</div>
									<div
										class="w-50 d-flex mob-w100 justify-content-end mob-w100 mob-mt-3"
									>
										<article
											v-if="interviewStats"
											class="pd-ir-tooltip position-relative d-flex align-items-center gap-2"
										>
											<span class="color-252525 mobfs-24 fam-roboto fs-32 fw-B">
												{{ panelInterviews[0].length }}
											</span>
											<span
												class="color-252525 fam-roboto fs-16 mobfs-14 fw-M"
												style="line-height: 1"
												>Interview Request</span
											>
											<span @click="scrollToBottom()" class="pointer">
												<img
													src="@/assets/paneldashboard/circle-arrow.svg"
													alt
												/>
											</span>

											<span class="tooltiparw">
												<img
													src="@/assets/paneldashboard/tooltiparw.svg"
													alt=""
												/>
											</span>
										</article>

										<img
											src="@/assets/paneldashboard/rightimage.svg"
											alt
											v-if="isLaptop"
										/>
										<img
											src="@/assets/paneldashboard/mobrightimage.svg"
											alt
											v-else
										/>
									</div>
								</div>
							</section>
						</div>
					</section>

					<!-- recenet interview -->
					<section v-else class="w-50 mob-w100 mob-mt-3 mobml-0 ml-2">
						<section class="pd-top-container">
							<div class="d-flex justify-content-between">
								<span class="fs-16 fw-LM text-black fam-lato"
									>Recent Interviews</span
								>
								<span
									@click="gotToViewAll(2)"
									class="fs-14 mobfs-12 fw-M text-blue fam-mont pointer d-flex align-items-center"
								>
									View All
									<img
										src="@/assets/paneldashboard/arrow.svg"
										class="ml-1"
										alt
									/>
								</span>
							</div>
							<hr style="border-top: 1px solid #dddddd" class="my-2" />
							<section v-if="showLoader[2]" class="h-100 d-flex flex-column">
								<PanelKanbanShimmer :rows="1" v-if="showLoader[2]" />
							</section>
							<section v-else-if="panelInterviews[2].length == 0" class="">
								<div
									class="h-100 d-flex align-items-center justify-content-center flex-column"
								>
									<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
									<div class="fs-14 fam-mont fw-LM color-344054">
										{{ getNoDataText(2) }}
									</div>
								</div>
							</section>
							<section v-else>
								<section
									:ref="`susScrollContainer2`"
									class="d-flex align-items-center overflow-auto w-100 gap-2 suspended-int-card"
									@scroll="scrollVert(2, $event)"
								>
									<div
										v-for="interview in panelInterviews[2]"
										:key="interview.interviewRequestID"
										class="suspendcards mb-2"
									>
										<InetrviewRequestCard
											:type="'suspended'"
											:level="2"
											:interview="interview"
											:isLaptop="isLaptop"
											@view-feedback="viewFeedbackData(interview)"
											@cancel-interview="showCancelInterview(interview, $event)"
											@accept-reject="showAcceptRejectModal($event, interview)"
											@show-jobdetails="showJobDetails($event, interview, 2)"
											@gotofeedback="goToFeedback()"
										/>
									</div>
									<div
										class="text-center d-flex just-content-center align-items-center"
										v-if="spinners[2]"
									>
										<b-spinner class="ml-auto"></b-spinner>
									</div>
								</section>
								<HorizontalSlider
									v-if="
										getScrollContainerSus() && panelInterviews[2].length > 1
									"
									id="kanban-slider"
									:dataList="panelInterviews[2]"
									:scrollContainerRef="getScrollContainerSus()"
									:scrollContainerId="`susscrollContainerNew2`"
								/>
							</section>
						</section>
					</section>

					<section
						class="w-50 mob-w100 mobml-0 ml-2 pd-top-container mob-mt-3"
						v-if="!isLaptop"
					>
						<div
							class="d-flex justify-content-between"
							v-if="
								!isLoadingGraph &&
								interviewStats &&
								interviewStats.interviewsTaken.totalInterviewsByHim > 0
							"
						>
							<span class="fs-16 fw-M text-black fam-lato">Interviews</span>
							<div
								class="pd-report-dd d-flex align-items-center gap-3"
								ref="filterBtn"
								@click="showFilter = true"
							>
								{{
									selectedTimeline.value == "last"
										? `Last ${customQuantity} ${customUnit}`
										: selectedTimeline.display
								}}
								<img src="../../assets/paneldashboard/downarrow.svg" alt="" />
							</div>
						</div>
						<hr style="border-top: 1px solid #dddddd" class="my-2" />

						<div v-if="isLoadingGraph" style="width: 100%">
							<Spinner
								style="width: 100%; height: 35vh"
								:id="'interviewGraph'"
							/>
						</div>
						<section
							v-if="
								!isLoadingGraph &&
								interviewStats &&
								interviewStats.interviewsTaken.totalInterviewsByHim == 0
							"
							style="height: 250px"
							class="d-flex align-items-center justify-content-center w-100 flex-column"
						>
							<img src="@/assets/paneldashboard/empty-graph.svg" alt="" />
							<div class="fs-14 fam-lato fw-LM color-344054 mt-2">
								No Data available
							</div>
						</section>
						<template v-else>
							<article
								v-if="!isLoadingGraph"
								id="hideinlaptop"
								class="interview-graph-bullet fs-11 fw-LM text-darkgrey fam-mont"
							>
								<div class="d-flex align-items-center gap-2">
									<div class="pd-interviewtaken"></div>
									Your Interviews Taken
								</div>

								<div class="d-flex align-items-center gap-2 mt-1">
									<div class="bg-avgint-taken pd-interviewtaken"></div>
									Average Interviews Taken
								</div>
							</article>
							<div class="d-flex mobflex-col w-100 mt-1 p-1 position-relative">
								<div id="interviewgraph" style="width: 100%" class="mt-3"></div>
							</div>
						</template>
					</section>
				</section>
				<!-- graph of interviews -->

				<section class="mt-3 w-100 pd-top-container hideinmob">
					<div class="d-flex justify-content-between">
						<div class="fs-16 fw-M text-black fam-lato">Interviews</div>
						<div
							v-if="
								!isLoadingGraph &&
								interviewStats &&
								interviewStats.interviewsTaken.totalInterviewsByHim != 0
							"
							class="d-flex align-items-center"
						>
							<div
								class="fs-11 fw-LM text-darkgrey fam-mont d-flex align-items-center"
							>
								<div class="pd-interviewtaken mr-1"></div>
								Your Interviews Taken
								<div class="bg-avgint-taken pd-interviewtaken mr-1 ml-3"></div>
								Average Interviews Taken
							</div>
							<div
								class="position-relative ml-2 pd-filter pointer"
								ref="pd-filter"
								v-closable="{
									exclude: ['pd-report-ddbox', 'pd-filter'],
									handler: 'closeDpd',
								}"
							>
								<div
									class="pd-report-dd d-flex align-items-center gap-3"
									@click="toggleFilter"
								>
									{{
										selectedTimeline.value == "last"
											? `Last ${customQuantity} ${customUnit}`
											: selectedTimeline.display
									}}
									<img src="../../assets/paneldashboard/downarrow.svg" alt="" />
								</div>
								<div
									class="pd-report-ddbox"
									ref="pd-report-ddbox"
									v-if="showdp"
								>
									<div
										v-for="option in timelineOptions"
										:key="option.value"
										:class="
											(option.value == selectedTimeline.value && !showCustom) ||
											(showCustom && option.value == 'last')
												? 'pd-custom-select'
												: ''
										"
										class="pd-report-ddbox-option d-flex align-items-center pointer"
										@click="setTimeline(option)"
									>
										<div
											class="d-flex align-items-center justify-content-between w-100"
											@click="showCustom = !showCustom"
										>
											<span class="ml-2">{{ option.display }}</span>
											<img
												v-if="option.display == 'Custom'"
												src="../../assets/paneldashboard/custom-right-arrow.svg"
												alt=""
											/>
										</div>
									</div>
									<div class="custom-filter-container" v-if="showCustom">
										<h5 class="fam-lato fw-LM fs-16 text-black">
											Apply Custom Filter
										</h5>
										<div class="custom-filter-inputs">
											<span class="fam-lato fw-LM fs-13 text-3A3C40"
												>Last:</span
											>
											<input
												type="number"
												v-model="customQuantity"
												min="1"
												placeholder="Enter"
												class="custom-quantity-input"
												@input="validateCustomQuantity"
												@keydown="preventInvalidKey"
											/>
											<select
												v-model="customUnit"
												class="custom-unit-select"
												@change="onCustomUnitChange"
											>
												<option value="" disabled>Select</option>
												<option value="weeks">Weeks</option>
												<option value="months">Months</option>
												<option value="years">Years</option>
											</select>
										</div>
										<span class="error-msg" v-if="showError">{{
											customError
										}}</span>
										<div
											class="d-flex align-items-center justify-content-between mt-2"
										>
											<Checkbox
												:vmodel="include"
												:label="'Include this ' + customUnit"
												@select-value="handleIncludeChange"
											/>

											<b-button
												v-if="customQuantity"
												@click.stop="clearCustomFilter"
												class="cancel-btn"
											>
												Clear
											</b-button>
											<b-button
												@click.stop="applyCustomFilter"
												class="custom-apply-btn"
												:disabled="!customQuantity || !customUnit || showError"
											>
												OK
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr style="border-top: 1px solid #dddddd" class="my-2" />
					<div v-if="isLoadingGraph" style="width: 100%">
						<Spinner
							style="width: 100%; height: 300px"
							:id="'interviewGraph'"
						/>
					</div>
					<section
						v-else-if="
							!isLoadingGraph &&
							interviewStats &&
							interviewStats.interviewsTaken.totalInterviewsByHim == 0
						"
						style="height: 250px"
						class="d-flex align-items-center justify-content-center w-100 flex-column"
					>
						<img src="@/assets/paneldashboard/empty-graph.svg" alt="" />
						<div class="fs-14 fam-lato fw-LM color-344054 mt-2">
							No Data available
						</div>
					</section>
					<div
						id="interviewgraph"
						style="width: 100%"
						:style="
							(!interviewStats ||
								(!isLoadingGraph &&
									interviewStats &&
									interviewStats.interviewsTaken.totalInterviewsByHim == 0)) &&
							'display: none;'
						"
						class="mt-3"
					></div>
				</section>
				<section
					v-if="!userInfo.isPanelSuspended"
					class="mt-3 w-100"
					:class="isLaptop ? ' pd-top-container' : ''"
					ref="scrollContainerinterview"
				>
					<div class="d-flex justify-content-between">
						<div class="s-16 fw-M text-black fam-lato hideinmob">
							Your Interviews
						</div>
						<div
							v-if="!checkAllIntEmpty()"
							id="hideinmobile"
							@click="gotToViewAll(0)"
							class="fs-14 mobfs-12 fw-LM text-blue fam-mont pointer"
						>
							View All
							<img
								src="@/assets/paneldashboard/arrow.svg"
								class="ml-1"
								alt=""
							/>
						</div>
					</div>
					<hr style="border-top: 1px solid #dddddd" class="my-2 hideinmob" />
					<!-- empty interview -->
					<section
						style="height: 250px"
						v-if="
							checkAllIntEmpty() &&
							isLaptop &&
							!intrwsLoading &&
							!checkAnyLoading()
						"
						class="hideinmob"
					>
						<div
							class="h-100 d-flex align-items-center justify-content-center flex-column"
						>
							<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
							<div class="fs-14 fam-lato fw-LM color-344054">
								No Interview Requests
							</div>
						</div>
					</section>
					<section
						v-else
						:class="isLaptop ? 'pd-kanban-card-container d-flex mt-3' : ''"
					>
						<section
							v-for="(interviews, index) in panelInterviews"
							:key="index"
							class="kanban-cards-container"
							:class="!isLaptop && 'mt-3'"
						>
							<div
								class="pd-kanban-topheader d-flex justify-content-between align-items-center w-100 hideinmob"
							>
								<div class="color-3a3c40 fs-12 fw-M fam-mont">
									{{ getLevelName(index) }}
								</div>
								<div class="pd-kanban-count fs-11 fw-M text-blue fam-mont">
									{{ total[index] }}
								</div>
							</div>
							<div
								class="d-flex align-items-center justify-content-between hideinlaptop"
							>
								<span class="fs-16 fw-LM text-black fam-lato">{{
									getLevelName(index)
								}}</span>
								<span
									class="fs-14 fw-LM mobfs-12 text-blue fam-mont"
									v-if="interviews.length != 0"
									@click="checkAndGoToMobile(index)"
								>
									View All
									<img
										src="@/assets/paneldashboard/arrow.svg"
										class="ml-1"
										alt
									/>
								</span>
							</div>
							<hr style="border-top: 1px solid #dddddd" class="my-2" />
							<section
								v-if="showLoader[index] && isLaptop"
								class="h-80 d-flex align-items-center"
							>
								<SmallSpinner />
							</section>
							<PanelKanbanShimmer
								:rows="1"
								v-else-if="showLoader[index] && !isLaptop"
							/>
							<section v-else-if="interviews.length == 0" class="h-80">
								<div
									class="h-100 d-flex align-items-center justify-content-center flex-column"
								>
									<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
									<div class="fs-14 fam-lato fw-LM color-344054">
										{{ getNoDataText(index) }}
									</div>
								</div>
							</section>
							<template v-else>
								<div
									:ref="`scrollContainerNew${index}`"
									class="pd-kanban-cards mob-mt-3"
									@scroll="
										isLaptop
											? scrollInt(index, $event)
											: scrollVert(index, $event)
									"
								>
									<section
										v-for="interview in interviews"
										:key="interview.interviewRequestID"
										class="mr-0 my-2 ml-2 pr-1"
									>
										<!-- empty interview -->

										<InetrviewRequestCard
											:level="index"
											:interview="interview"
											:isLaptop="isLaptop"
											@view-feedback="viewFeedbackData(interview)"
											@cancel-interview="showCancelInterview(interview, $event)"
											@accept-reject="showAcceptRejectModal($event, interview)"
											@show-jobdetails="
												showJobDetails($event, interview, index)
											"
											@gotofeedback="goToFeedback()"
											@reschedule-interview="rescheduleInterview(interview)"
										/>
									</section>
									<div
										class="text-center"
										:class="
											!isLaptop &&
											'd-flex just-content-center align-items-center'
										"
										v-if="spinners[index]"
									>
										<b-spinner class="ml-auto"></b-spinner>
									</div>
								</div>
								<HorizontalSlider
									v-if="
										!isLaptop &&
										getScrollContainer(index) &&
										interviews.length > 1
									"
									id="kanban-slider"
									:dataList="interviews"
									:scrollContainerRef="getScrollContainer(index)"
									v-model="scrollValues[index]"
									:scrollContainerId="`scrollContainer${index}`"
									class="hideinlaptop"
								/>
							</template>
						</section>
					</section>
				</section>
			</section>
		</main>
		<Transition name="slidemob">
			<div
				class="filter-box-mob h-unset p-3"
				ref="filter-box-mob"
				v-if="showFilter"
				v-closable="{
					exclude: ['filter-box-mob', 'custom-filter-box-mob', 'filterBtn'],
					handler: 'closeFilter',
				}"
			>
				<article class="blue-drag"></article>
				<h5 class="fam-lato fw-B fs-18 text-black mt-3">Filters</h5>
				<div class="mob-radio-group panel-radio-fs-14">
					<b-form-group>
						<b-form-radio-group v-model="selectedTimeline" size="md" stacked>
							<b-form-radio
								v-for="option in timelineOptions"
								:key="option.value"
								:value="option"
								:checked="showCustom"
							>
								{{ option.display }}
							</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</div>
				<hr class="hr-back" />
				<div class="d-flex align-items-center justify-content-between">
					<article class="mob-cancelBtn w-25">
						<b-button class="w-100" @click="resetFiter()">Clear</b-button>
					</article>
					<article class="mob-addBtn w-25">
						<b-button class="w-100" @click="setTimeline(selectedTimeline)"
							>Apply</b-button
						>
					</article>
				</div>
			</div>
		</Transition>
		<Transition name="slidemob">
			<div
				id="hideinlaptop"
				class="filter-box-mob h-unset p-3"
				v-if="showFilter2"
				ref="custom-filter-box-mob"
				v-closable="{
					exclude: ['filter-box-mob', 'custom-filter-box-mob', 'filterBtn'],
					handler: 'closeFilter',
				}"
			>
				<article class="blue-drag"></article>
				<h5 class="fam-lato fw-B fs-18 text-black">Custom View</h5>
				<div class="custom-filter-inputs mt-3">
					<span class="fam-lato fw-LM fs-13 text-3A3C40">Last:</span>
					<input
						type="number"
						v-model="customQuantity"
						min="1"
						placeholder="Enter number"
						class="custom-quantity-input"
						@input="validateCustomQuantity"
						@keydown="preventInvalidKey"
					/>
					<select v-model="customUnit" class="custom-unit-select">
						<option value="" disabled>Select</option>
						<option value="weeks">Weeks</option>
						<option value="months">Months</option>
						<option value="years">Years</option>
					</select>
				</div>
				<div class="mt-3">
					<Checkbox
						:vmodel="include"
						:label="'Include this ' + customUnit"
						@select-value="handleIncludeChange"
					/>
				</div>
				<hr class="hr-back" />
				<div class="d-flex align-items-center justify-content-between">
					<article class="mob-cancelBtn w-25">
						<b-button class="w-100" @click="showFilter2 = false">Back</b-button>
					</article>
					<article class="mob-addBtn w-25">
						<b-button
							class="w-100"
							:disabled="!customQuantity || !customUnit"
							@click="applyCustomFilter"
							>Ok</b-button
						>
					</article>
				</div>
			</div>
		</Transition>
		<!-- modal for feedback component -->
		<b-modal
			id="giveFdbkModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showFeedBack"
			@hidden="closedFeedback()"
		>
			<section class="candash-modal-top px-3 py-2">
				<div class="ml-1">
					<div class="candash-modal-head">Give Feedback</div>
				</div>
				<div
					class="d-flex align-items-center gap-3 justify-content-end pointer"
				>
					<!-- <div class="ct-table-switch d-flex align-items-center apply-font">
						<b-form-checkbox
							switch
							style="margin-top: 5px !important"
						></b-form-checkbox>
						No Show
					</div> -->
					<img
						@click="closedFeedback()"
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
			</section>
			<section class="height">
				<GiveFeedback
					v-if="showFeedBack"
					@fromFeedback="closedFeedback($event)"
				/>
			</section>
		</b-modal>
		<b-modal
			id="View-Fdbk-Modal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showViewFeedback"
			@hidden="hideViewFeedback()"
		>
			<section class="candash-modal-top px-3 py-2">
				<div class="ml-1">
					<div class="candash-modal-head">View Feedback</div>
				</div>
				<div
					class="d-flex align-items-center gap-3 justify-content-end pointer"
				>
					<!-- <div class="ct-table-switch d-flex align-items-center apply-font">
						<b-form-checkbox
							switch
							style="margin-top: 5px !important"
						></b-form-checkbox>
						No Show
					</div> -->
					<img
						@click="hideViewFeedback()"
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
			</section>
			<section class="height">
				<ViewFeedback
					:interview="selectedInterview"
					@close-modal="hideViewFeedback()"
				/>
			</section>
		</b-modal>
		<!-- for showing in mobile bind modal-class="bottom-modal" and remove centered -->
		<SlotPreferenceModal
			v-if="showSlotModal"
			:showSlotModal="showSlotModal"
			:isLaptop="isLaptop"
			:slotDataVal="slotData"
			@close-modal="closeModal"
		/>

		<JobDetailsModal
			v-if="showJobDetailsModal"
			:showJobDetailsModal="showJobDetailsModal"
			:interview="selectedInterview"
			:level="selectedLevel"
			@view-feedback="viewFeedbackData(selectedInterview)"
			@accept-reject="showAcceptRejectModal($event, selectedInterview)"
			@close-modal="hideJobDetails()"
			@gotofeedback="goToFeedback()"
		/>

		<AcceptRejectModal
			v-if="showAcceptReject || cancelInterview"
			:showAcceptReject="showAcceptReject || cancelInterview"
			:interview="selectedInterview"
			:type="actionType"
			:cancel="cancelInterview"
			@success="
				checkAndClose('success', $event), getAllPanelData(), getInterviewStats()
			"
			@close-modal="checkAndClose('close')"
			@reschedule-interview="rescheduleInterview"
		/>

		<RevokeRequest
			v-if="showRevokeRequest"
			:showRevokeRequest="showRevokeRequest"
			:isLaptop="isLaptop"
			@request-submitted="getTicketHistory()"
			@close-modal="showRevokeRequest = false"
		/>

		<TicketHistoryModal
			:showModal="showTicketHistoryModal"
			:ticketData="ticketHistory"
			@close="showTicketHistoryModal = false"
		/>
		<InterviewSlotModal
			v-if="showSlots"
			:showSlots="showSlots"
			:selectedJob="selectedInterview"
			:parentMessage="'Confirm'"
			:reschedule="true"
			@updateStatus="updateInterviewStatus"
			@closeSlots="closeSlots"
		/>
		<b-modal
			v-if="showSuspendedModal"
			id="suspendedmodal"
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showSuspendedModal"
			modal-class="bottom-modal"
		>
			<section class="d-flex justify-content-between">
				<div class="d-flex flex-column">
					<div class="fs-14 fw-800 text-red fam-lato let-spac12">
						{{
							shouldShowAppealOption()
								? "SUSPENDED"
								: ticketHistory.refernceObject.panelistNotRevoked
								? "REVOKE REQUEST REJECTED"
								: "REVOKE REQUEST SUBMITTED"
						}}
					</div>

					<div class="text-darkgrey fs-16 fam-lato fw-B mt-1">
						{{
							shouldShowAppealOption()
								? "You have been suspended for 7 days for frequently cancelling interviews."
								: ticketHistory.refernceObject.panelistNotRevoked
								? "Your request has been rejected, and your account will remain suspended for 7 days"
								: "Your revoke request has been submitted. We will get back to you shortly."
						}}
					</div>
				</div>
				<img
					@click="showSuspendedModal = false"
					class="rotate-on-hover"
					src="@/assets/newdesign/dashboard/blueCross.svg"
					alt=""
				/>
			</section>
			<hr style="border-top: 1px solid rgb(129 125 125)" class="my-2" />
			<section class="height">
				<div class="fs-14 fw-M fam-mont text-darkgrey">
					Cancelled Interviews:
				</div>
				<section
					ref="scrollContainer"
					class="d-flex align-items-center mobgap3 overflow-auto scrollable-content"
				>
					<div
						class="cancelint-cards"
						v-for="(ticket, index) in ticketHistory.refernceObject
							.lastFiveCancelled"
						:key="index"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div class="ci-intid d-flex align-items-center">
								<span class="mob-fw-400 text-blue fs-11 fam-lato"
									>Interview ID:</span
								>
								<span class="mob-fw-500 color-3a3c40 fs-11 fam-lato">
									{{ ticket.interviewRequestID }}</span
								>
							</div>
							<div class="five">
								<img
									@click="showTicketDetails(ticket)"
									class="arrow-icon-2"
									src="../../assets/newdesign/myprofile/roundRightArrow.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="d-flex align-items-center">
							<span class="fw-LM fam-lato fs-12 color-727478">
								Interview Date & Time:
							</span>
							&nbsp;
							<span class="mob-fw-600 color-3a3c40 fs-11 fam-lato">{{
								formatDate(ticket.slot)
							}}</span>
						</div>
						<div class="d-flex align-items-center">
							<span class="fw-LM fam-lato fs-12 color-727478"> Job Name: </span>
							&nbsp;
							<span class="mob-fw-600 color-3a3c40 fs-11 fam-lato">
								{{ ticket.jobInfo.title }}
							</span>
						</div>
						<div class="d-flex align-items-center">
							<span class="fw-LM fam-lato fs-12 color-727478">
								Recruiter Name:
							</span>
							&nbsp;
							<span class="mob-fw-600 color-3a3c40 fs-11 fam-lato">
								{{ ticket.LeadRecruiterName || "N/A" }}
							</span>
						</div>
					</div>
				</section>
				<input
					v-model="scrollValue"
					type="range"
					min="0"
					:max="scrollMax"
					@input="scrollCards"
					class="slider pointer"
				/>
				<section class="mt-3">
					<div>
						<div class="fam-mont fw-400 fs-13 text-primary">Reason:</div>
						<div class="fam-lato fw-R fs-15 text-darkgrey">
							{{ ticketHistory.activity[0].title }}
						</div>
					</div>
					<div class="mt-3">
						<div class="fam-mont fw-400 fs-13 text-primary mt-3">Remarks:</div>
						<div class="fam-lato fw-R fs-15 text-darkgrey">
							{{ ticketHistory.activity[0].remarks }}
						</div>
					</div>
				</section>
				<div
					class="mt-3 d-flex align-items-center w-100 justify-content-between"
				>
					<div class="d-flex align-items-center gap-2">
						<img src="@/assets/paneldashboard/remarks-dp.svg" alt="" />
						<div>
							<div class="font-lato fw-600 fs-14 color-black">
								{{
									ticketHistory.activity[0].activityByName
										? ticketHistory.activity[0].activityByName
										: "N/A"
								}}
							</div>
							<div class="font-mont fs-13 fw-400 color-627290">
								{{ ticketHistory.activity[0].activityAt }}
							</div>
						</div>
					</div>

					<div
						@click="showTicketHistoryModal = true"
						class="font-mont fw-600 fs-14 color-mainblue text-underline d-flex align-items-center gap-1 pointer"
					>
						<img src="@/assets/paneldashboard/show-history.svg" alt="" />
						Show Ticket History
					</div>
				</div>
				<hr style="border-top: 1px solid rgb(153 157 163)" class="mb-0 mt-2" />

				<div class="px-3 pt-3 w-100 d-flex justify-content-end gap-2">
					<div>
						<b-button
							class="candash-cancelBtn pointer"
							@click="showSuspendedModal = false"
							>Cancel</b-button
						>
					</div>
					<b-button
						id="hideinmobile"
						class="candash-addBtn"
						v-if="shouldShowAppealOption()"
						@click="showRevokeRequest = true"
						>Request Re-activation</b-button
					>
				</div>
			</section>
		</b-modal>
	</div>
</template>

<script>
import "@/assets/paneldashboard/paneldashboard.css";
import GiveFeedback from "@/components/PanelDashboardModals/GiveFeedback.vue";
import HorizontalSlider from "../../components/fixedcomponents/HorizontalScroll.vue";
import commonFunc from "@/components/mixin/commonFunction.js";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import InetrviewRequestCard from "@/components/PanelDasboard/InetrviewRequestCard.vue";
import Checkbox from "@/components/InputComponents/Checkbox.vue";
import { InterviewProgress, EarningGraph } from "./InterviewGraph";
import {
	getInterviewGraph,
	getPanelStreak,
	getInterviewData,
	getTicketHistory,
} from "@/utils/apiFunctions";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import { vendorStat } from "vue-d3-charts-hire3x";
import SlotPreferenceModal from "./modals/SlotPreferenceModal.vue";
import toast from "@/components/mixin/toast";
import panelDashboardMixin from "@/components/mixin/panelDashboardMixin";
import { getPanelSlot } from "@/utils/apiFunctions";
import SmallSpinner from "@/components/fixedcomponents/SmallSpinner.vue";
import { Capacitor } from "@capacitor/core";
import TicketHistoryModal from "./modals/TicketHistoryModal.vue";
import InterviewSlotModal from "@/components/JobProgress/InterviewSlotModal.vue";

export default {
	data() {
		return {
			scrollValue: 0,
			scrollMax: 100,
			scrollWithRange: "",
			showTicketHistoryModal: false,
			suspendCollapse: false,
			showFilter: false,
			showFilter2: false,
			interviewData: { totalEarning: { percentDiff: {} } },
			include: false,
			showCustom: false,
			earningGraphData: [],
			noskills: 6,
			preftime: 3,
			showdp: false,
			showSlotModal: false,
			scrollValues: {},
			scrollContainers: [],
			scrollValue: 0,
			slotData: {},
			showFeedBack: false,
			selectedTimeline: { display: "This Week", value: "thisWeek" },
			timelineOptions: [
				{ display: "This Week", value: "thisWeek" },
				{ display: "This Month", value: "thisMonth" },
				{ display: "This Year", value: "thisYear" },
				{ display: "Apply Custom", value: "last" },
			],
			interviewGraphData: [],
			customQuantity: 0,
			customUnit: "",
			unit: "",
			quantity: 0,
			isLoadingGraph: false,
			showMore: false,
			graphLoader: false,
			// Month name mapping for consistent formatting
			monthMap: {
				"01": "Jan",
				"02": "Feb",
				"03": "Mar",
				"04": "Apr",
				"05": "May",
				"06": "Jun",
				"07": "Jul",
				"08": "Aug",
				"09": "Sep",
				10: "Oct",
				11: "Nov",
				12: "Dec",
			},
			scrollValue: 0,
			scrollMax: 100,
			customError: "",
			showError: false,
			ticketHistory: {},
			showSuspendedModal: false,
		};
	},
	mixins: [commonFunc, toast, panelDashboardMixin],
	components: {
		NcdTopContainer,
		InetrviewRequestCard,
		HorizontalSlider,
		SlotPreferenceModal,
		GiveFeedback,
		Spinner,
		Checkbox,
		SmallSpinner,
		TicketHistoryModal,
		InterviewSlotModal,
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
		this.removeTooltip();
	},
	created() {
		this.getInterviewData();
		this.getSlotData();
		this.getAllPanelData();
		this.getTicketHistory();
		this.graphLoader = true;
		this.isLoadingGraph = true;
		setTimeout(() => {
			this.getInterviewGraph();
			this.getEarningGraph();
		}, 2000);
		this.getInterviewStats();
	},
	methods: {
		updateInterviewStatus() {
			this.getPanelInterviews(1);
			this.closeSlots();
		},
		closeSlots() {
			this.showSlots = false;
		},
		shouldShowAppealOption() {
			const count = Number(this.ticketHistory.refernceObject?.appealCount);
			return isNaN(count) || count < 1;
		},

		calculateScrollMax() {
			// Calculate the max scrollable width of the content
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				const scrollWidth = scrollContainer.scrollWidth;
				const clientWidth = scrollContainer.clientWidth;
				this.scrollMax = scrollWidth - clientWidth;
			}
		},
		scrollCards() {
			// Scroll the content based on the slider value
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				scrollContainer.scrollLeft = this.scrollValue;
			}
		},
		updateSliderOnScroll() {
			// Update the slider value based on the div scroll position
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				this.scrollValue = scrollContainer.scrollLeft;
			}
		},
		openSuspendedDetails() {
			if (this.isLaptop) {
				this.suspendCollapse = !this.suspendCollapse;
			} else {
				this.showSuspendedModal = true;
				setTimeout(() => {
					const scrollContainer = this.$refs.scrollContainer;
					if (scrollContainer) {
						scrollContainer.addEventListener(
							"scroll",
							this.updateSliderOnScroll
						);
					}
					this.calculateScrollMax();
				}, 1000);
			}
		},
		formatDate(date) {
			// <!-- 12.10.2024, 10:10 PM -->
			const options = {
				year: "numeric",
				month: "short",
				day: "numeric",
				hour: "numeric",
				minute: "numeric",
				hour12: true,
			};
			return new Date(date).toLocaleString("en-US", options);
		},
		showTicketDetails(ticket) {
			const details = {
				interviewRequestID: ticket.interviewRequestID || "N/A",
				jobName: ticket.jobInfo.title || "N/A",
				jobType: ticket.jobInfo.jobType || "N/A",
				role: ticket.jobInfo.role || "N/A",
				description: ticket.jobInfo.description || "N/A",
				skills: ticket.jobInfo.skills || [],
				candidateSkills:
					this.formatCandidateSkills(ticket.candidateInfo.skills) || [],
				amount: ticket.interviewInfo.amount || "N/A",
				name:
					ticket.candidateInfo?.firstName || ticket.candidateInfo?.lastName
						? [ticket.candidateInfo?.firstName, ticket.candidateInfo?.lastName]
								.filter(Boolean)
								.join(" ")
						: "N/A",
				emailID: ticket.emailID,
				link: ticket.candidateInfo?.link,
				slot: this.formatSlot(ticket.slot) || "N/A",
				slotStartTime: this.formatSlot(ticket.slot, true) || "N/A",
				fromTicket: true,
			};
			this.showJobDetails(true, details, 2);
		},
		formatSlot(isoString, isStartTime = false) {
			const startDate = new Date(isoString);
			const endDate = new Date(startDate.getTime() + 30 * 60000);

			const pad = (n) => (n < 10 ? "0" + n : n);

			const formatTime = (date) => {
				let hours = date.getHours();
				const minutes = pad(date.getMinutes());
				const ampm = hours >= 12 ? "PM" : "AM";
				hours = hours % 12;
				hours = hours ? hours : 12;
				return `${pad(hours)}:${minutes} ${ampm}`;
			};

			const day = pad(startDate.getDate());
			const month = pad(startDate.getMonth() + 1);
			const year = startDate.getFullYear();
			if (isStartTime) {
				return `${day}.${month}.${year}, ${formatTime(startDate)}`;
			}
			return `${day}.${month}.${year}, ${formatTime(startDate)} - ${formatTime(
				endDate
			)}`;
		},
		formatCandidateSkills(skills) {
			let candidateSkills = [];
			skills.forEach((skill) => {
				candidateSkills.push(skill.skillName);
			});
			return candidateSkills;
		},
		async getTicketHistory() {
			const res = await getTicketHistory();
			if (res.status == 200) {
				this.ticketHistory = res.data.data;
				console.log("ticketHistory", this.ticketHistory);
			}
		},
		clearCustomFilter() {
			this.showCustom = false;
			this.showdp = false;
			this.customQuantity = 0;
			this.customUnit = "";
		},
		onCustomUnitChange() {
			let max;
			this.showError = false;
			if (this.customUnit === "weeks") {
				max = 5;
			} else if (this.customUnit === "months") {
				max = 12;
			}
			if (this.customQuantity > max) {
				this.customError = `Maximum ${max} ${this.customUnit} allowed`;
				this.showError = true;
			}
		},
		goToTransaction() {
			this.$router.push("/transaction");
		},
		checkAnyLoading() {
			return this.showLoader.includes(true);
		},
		validateCustomQuantity(event) {
			let value = parseInt(event.target.value, 10);
			if (isNaN(value) || value < 1) {
				this.customQuantity = "";
			} else if (value > 99) {
				this.customQuantity = 99;
			} else {
				this.customQuantity = value;
			}
			this.onCustomUnitChange();
		},
		preventInvalidKey(event) {
			if (
				event.keyCode === 69 ||
				(event.keyCode >= 187 && event.keyCode <= 189) ||
				event.keyCode === 190 ||
				event.keyCode === 110
			) {
				event.preventDefault();
				return;
			}
		},
		toggleFilter() {
			this.showCustom = false;
			this.showdp = !this.showdp;
		},
		closeFilter() {
			this.showFilter = false;
			this.showFilter2 = false;
		},
		setPanelSkills() {
			this.showMore = !this.showMore;
			if (this.showMore) {
				this.panelSkills = this.panelInformation.skills;
			} else {
				this.panelSkills = this.panelInformation.skills.slice(0, 5);
			}
		},
		scrollToBottom() {
			const container = this.$refs.scrollContainerinterview;
			if (container) {
				container.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}
		},
		closeDpd() {
			this.showdp = false;
			this.showCustom = false;
		},
		checkAllIntEmpty() {
			return !this.total[0] && !this.total[1] && !this.total[2];
		},
		async getInterviewData() {
			try {
				const res = await getInterviewData();
				if (res.status == 200) {
					this.interviewData = res.data.data;
				} else {
					this.interviewData = null;
				}
			} catch (error) {
				this.interviewData = null;
				console.log(error);
			}
		},
		async goToPayment() {
			if (Capacitor.isNativePlatform())
				window.location.replace("https://utility.hire3x.com/wallet");
			else window.open("https://utility.hire3x.com/wallet");
		},
		async getSlotData() {
			this.slotLoader = true;
			try {
				const res = await getPanelSlot();
				if (res.status == 200) {
					if (Object.keys(res.data.data).length != 0) {
						this.slotData = res.data.data;
						this.$forceUpdate();
					} else {
						this.slotData = null;
						this.showSlotModal = true;
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		getCurrentAndLastMonth() {
			const currentDate = new Date();

			let currentMonth = currentDate.getMonth();
			let currentYear = currentDate.getFullYear();

			let lastMonth = currentMonth - 1;
			let lastYear = currentYear;

			if (lastMonth < 0) {
				lastMonth = 11;
				lastYear = currentYear - 1;
			}

			const currentMonthFormatted = `${currentYear}-${String(
				currentMonth + 1
			).padStart(2, "0")}`;
			const lastMonthFormatted = `${lastYear}-${String(lastMonth + 1).padStart(
				2,
				"0"
			)}`;

			return [lastMonthFormatted, currentMonthFormatted];
		},
		getCurrentAndNextMonth() {
			const currentDate = new Date();

			const currentMonth = currentDate.getMonth();
			const currentYear = currentDate.getFullYear();

			const nextMonthDate = new Date(currentYear, currentMonth + 1);
			const nextMonth = nextMonthDate.getMonth();
			const nextYear = nextMonthDate.getFullYear();

			const currentMonthFormatted = `${currentYear}-${String(
				currentMonth + 1
			).padStart(2, "0")}`;
			const nextMonthFormatted = `${nextYear}-${String(nextMonth + 1).padStart(
				2,
				"0"
			)}`;

			return [currentMonthFormatted, nextMonthFormatted];
		},
		async getEarningGraph() {
			try {
				this.graphLoader = true;

				let payload = {
					months: this.getCurrentAndLastMonth(),
				};

				const response = await getPanelStreak(payload);

				if (response?.status === 200) {
					this.earningGraphData = response.data.data.data;
					const createdAt = response.data.data.createdAt;

					const createdDate = new Date(createdAt);
					const createdMonth = createdDate.getMonth();
					const createdYear = createdDate.getFullYear();

					const now = new Date();
					const currentMonth = now.getMonth();
					const currentYear = now.getFullYear();

					if (createdMonth === currentMonth && createdYear === currentYear) {
						payload = {
							months: this.getCurrentAndNextMonth(),
						};

						const secondResponse = await getPanelStreak(payload);
						if (secondResponse?.status === 200) {
							this.earningGraphData = secondResponse.data.data.data;
						}
					}

					if (this.earningGraphData.length > 0) {
						const margin = this.isLaptop
							? { top: 8, right: 5, bottom: 3, left: 2 }
							: { top: 8, right: 5, bottom: 3, left: 15 };
						const numOfCol = 2;
						const cellSize = this.isLaptop ? 3 : 4;
						const height = this.isLaptop ? 1.2 : 1.5;
						const widthVal = 90;
						const showHeading = false;
						const monthGap = 12;
						const perRowCell = this.isLaptop ? 7 : 6;
						const cellGap = 1.8;
						const x_axis_cellGap = 1.8;
						const y_axis_cellGap = 1.8;

						const mapDataForChart = (data) => {
							return data.map((item) => ({
								day: item.dayOfMonth,
								year: item.year,
								month: item.month,
								count: item.totalEarnings,
							}));
						};

						setTimeout(() => {
							if (document.getElementById("heatmap2")) {
								const mappedData = mapDataForChart(this.earningGraphData);
								const earningGraph = new EarningGraph();
								earningGraph.heatmappanel(
									mappedData,
									numOfCol,
									cellSize,
									height,
									margin,
									widthVal,
									true,
									monthGap,
									perRowCell,
									cellGap,
									x_axis_cellGap,
									y_axis_cellGap,
									this.isLaptop
								);
							}
						}, 1000);
					}
				}
			} catch (error) {
				console.error("Error fetching earnings graph data:", error);
			} finally {
				this.graphLoader = false;
			}
		},
		removeTooltip() {
			const tooltips = document.querySelectorAll(".tooltip");
			if (tooltips.length > 0) {
				tooltips.forEach((tooltip) => {
					tooltip.remove();
				});
			}
		},
		async getInterviewGraph() {
			const graphContainer = document.getElementById("interviewgraph");
			// if (!graphContainer) return;

			if (graphContainer && graphContainer.innerHTML !== "") {
				graphContainer.innerHTML = "";
			}

			this.isLoadingGraph = true;

			try {
				const requestParams = {
					quantity: this.quantity,
					unit: this.unit,
					selectedTimeline: this.selectedTimeline.value,
					userID: this.userInfo.userID,
					includes: this.include,
				};

				const response = await getInterviewGraph(requestParams);

				if (response?.status == 200) {
					this.interviewGraphData = this.formatGraphData(response.data.data);

					const currentFilter = this.determineFilterType();

					const blueDot = require("@/assets/paneldashboard/blue-dot.svg");
					const pinkDot = require("@/assets/paneldashboard/pink-dot.svg");

					const interviewChart = new InterviewProgress();
					interviewChart.progressGraph(
						"#interviewgraph",
						"interviewgraph",
						this.interviewGraphData,
						currentFilter,
						blueDot,
						pinkDot
					);
				} else {
					console.error("Invalid response format from getInterviewGraph API");
				}
			} catch (error) {
				console.error("Error fetching interview graph data:", error);
			} finally {
				this.isLoadingGraph = false;
			}
		},

		formatGraphData(graphData) {
			if (!Array.isArray(graphData)) return [];

			return graphData.map((item) => {
				const { date, interviewsTakenCount, avgInterviewsTakenCount } = item;
				const parts = date.split("-");
				let day = null,
					month = null,
					year = null;

				switch (parts.length) {
					case 3:
						[day, month, year] = parts;
						day = parseInt(day);
						break;
					case 2:
						[month, year] = parts;
						break;
					case 1:
						year = parts[0];
						break;
					default:
						year = date;
				}

				return {
					year: parseInt(year),
					month: this.monthMap[month] || null,
					date: day,
					interviews: interviewsTakenCount,
					averageInterviews: avgInterviewsTakenCount,
				};
			});
		},
		determineFilterType() {
			const { value } = this.selectedTimeline;
			if (
				value == "thisWeek" ||
				value == "thisMonth" ||
				(value == "last" && this.unit == "weeks") ||
				(value == "last" && this.unit == "months" && this.quantity == 1)
			) {
				return "date";
			}
			if (value == "last" && this.unit == "years" && this.quantity > 1) {
				return "year";
			}
			return "month";
		},

		gotoirmobile() {
			this.$router.push({ name: "InterviewRequest" });
		},
		closedFeedback(val) {
			if (val && val.submitted) {
				this.showFeedBack = false;
				this.successModal("Success", "Feedback submitted successfully.");
				this.hideJobDetails();
				this.getInterviewData();
				this.getSlotData();
				this.getAllPanelData();
				const heatmapContainer = document.getElementById("heatmap2");
				if (heatmapContainer) {
					heatmapContainer.innerHTML = ""; // clear previous content
				}
				this.graphLoader = true;
				this.isLoadingGraph = true;
				setTimeout(() => {
					this.getInterviewGraph();
					this.getEarningGraph();
				}, 2000);
				this.getInterviewStats();
			} else {
				this.showFeedBack = false;
				this.$store.commit("candidateVUEX/setFeedbackData", {});
			}
		},
		goToFeedback() {
			if (this.isLaptop) {
				this.showFeedBack = true;
			} else {
				this.$router.push({ name: "GiveFeedback" });
			}
		},
		getScrollContainerSus() {
			return this.$refs.susScrollContainer2;
		},
		getScrollContainer(index) {
			if (this.scrollContainers[index]) {
				return this.scrollContainers[index]; // Return stored ref if available
			}
			this.$nextTick(() => {
				const ref = this.$refs[`scrollContainerNew${index}`];
				this.$set(
					this.scrollContainers,
					index,
					Array.isArray(ref) ? ref[0] : ref || null
				);
				this.$forceUpdate();
			});
			return null;
		},
		scrollVert(index, e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollLeft) >=
				target.scrollWidth - target.clientWidth - 10
			) {
				if (
					this.checkbetween(this.pageEnd[index], 0, this.total[index]) &&
					!this.spinners[index] &&
					!this.showLoader[index]
				) {
					this.spinners[index] = true;
					this.$forceUpdate();
					this.pages[index]++;
					this.getPanelInterviews(index);
				}
			}
		},
		checkAndGoToMobile(levelVal) {
			this.$router.push({
				name: "PanelInterviews",
				params: {
					level: levelVal,
				},
			});
		},
		getSkillSrc(skill) {
			let skillSrc;
			if (skill == "Java")
				skillSrc = require("@/assets/paneldashboard/java.svg");
			else if (skill == "Gitlab")
				skillSrc = require("@/assets/paneldashboard/gitlab.svg");
			else if (skill == "Flutter")
				skillSrc = require("@/assets/paneldashboard/flutter.svg");
			else if (skill == "Redux")
				skillSrc = require("@/assets/paneldashboard/redux.svg");
			else if (skill == "Github")
				skillSrc = require("@/assets/paneldashboard/github.svg");
			else if (skill == "Python")
				skillSrc = require("@/assets/paneldashboard/python.svg");
			else skillSrc = null;
			return skillSrc;
		},
		closeModal(type) {
			if (type) {
				this.successModal(
					"Successfully updated.",
					"Preferences updated successfully."
				);
				this.getSlotData();
			}
			this.showSlotModal = false;
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
		},
		gotoirmobile() {
			this.$router.push({ name: "PanelInterviews" });
		},
		gotorecentmobile() {
			this.$router.push({ name: "RecentInterview" });
		},
		gotoupcomingmobile() {
			this.$router.push({ name: "UpcomingInterview" });
		},

		setTimeline(option) {
			if (option.value == "last") {
				this.showFilter2 = true;
			}
			if (option.value !== "last") {
				this.showCustom = false;
				this.showFilter = false;
				this.include = false;
				this.selectedTimeline = option;
				this.showdp = false;
				this.getInterviewGraph();
			}
		},
		resetFiter() {
			this.showFilter = false;
			this.selectedTimeline = { display: "This Week", value: "thisWeek" };
			this.getInterviewGraph();
		},
		applyCustomFilter() {
			this.showCustom = false;
			this.showFilter = false;
			this.showFilter2 = false;
			this.selectedTimeline = {
				display: `Custom`,
				value: "last",
			};
			this.quantity = this.customQuantity;
			this.unit = this.customUnit;
			this.showdp = false;
			this.getInterviewGraph();
		},
		handleIncludeChange(value) {
			this.include = value;
		},
	},
};
</script>

<style>
.h-80 {
	height: 80%;
}
#interviewgraph {
	overflow-x: auto;
}
.pd-report-dd {
	padding: 4px 16px;
	background: rgba(32, 99, 155, 0.1);
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #615e83;
}
.pd-report-ddbox {
	padding: 10px;
	max-height: 240px;
	background: #ffffff;
	box-shadow: 0px 1px 11px 0px #00000061;
	border-radius: 6px;
	position: absolute;
	width: 230px;
	top: 30px;
	right: 0;
	z-index: 10;
}
.pd-report-ddbox-option {
	padding: 8px;
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 13px;
	color: #3a3c40;
	border-radius: 4px;
	transition: background-color 0.2s ease;
}
.pd-report-ddbox-option:hover {
	background-color: rgba(74, 58, 255, 0.05);
}
.bg-report-dd-selected {
	background: rgba(32, 99, 155, 0.1) !important;
}
.pd-custom-select {
	background: #20639b1a;
}
.custom-filter-container {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 15px;
	border-radius: 4px;
	width: 300px;
	position: absolute;
	box-shadow: 0px 1px 11px 0px #00000061;
	background-color: #ffffff;
	right: 219px;
	bottom: -102px;
}

.custom-filter-inputs {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
}

.custom-quantity-input {
	width: 67px;
	height: 37px;
	padding: 4px 8px;
	border: 1px solid #dddddd;
	border-radius: 8px;
	font-size: 12px;
	color: #3a3c40;
	font-family: "Lato", sans-serif;
}

.custom-unit-select {
	flex: 1;
	height: 37px;
	padding: 4px 8px;
	border: 1px solid #dddddd;
	border-radius: 8px;
	font-size: 12px;
	color: #3a3c40;
	font-family: "Lato", sans-serif;
	background-color: white;
}

.custom-apply-btn.btn-secondary {
	padding: 4px;
	width: 56px;
	background-color: #20639b;
	color: #ffffff;
	border: 1px solid #20639b;
	border-radius: 40px;
	font-size: 12px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
	cursor: pointer;
	transition: all 0.2s ease;
}
.custom-apply-btn.btn-secondary {
	background-color: #20639b;
}

.text-experience {
	font-family: Lato;
	font-weight: 700;
	font-style: Italic;
	font-size: 14px;
	text-transform: uppercase;
	color: #595959;
}
.custom-apply-btn.btn-secondary:hover {
	background-color: #20639b;
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.earn-loader {
	height: 140px !important;
}

.w-45 {
	width: 45% !important;
}
.h-10px {
	height: 20px !important;
}
.suspended-card {
	padding: 12px 16px;
	background: linear-gradient(0deg, #f9fcfd, #f9fcfd), #ffffff;
	border: 1px solid rgba(32, 99, 155, 0.1);
	border-radius: 10px;
}
.suspend-line {
	width: 18px;
	height: 0;
	border: 1px solid #888888;
	transform: rotate(90deg);
}
.let-spac12 {
	letter-spacing: 0.12em;
}
.suspendcards .card {
	width: 371px;
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.15);
	box-shadow: 0px 4px 5px 1px rgba(111, 111, 111, 0.17);
	border-radius: 8px;
	height: 215px;
}
.gap-2 {
	gap: 0.5rem;
}
.line-height {
	opacity: 0.5;
	border-width: 1px;
	color: #3f698e;
}

.error-msg {
	color: red;
	font-size: 13px;
}

.cancel-btn {
	border-radius: 40px !important;
	border: 1px solid var(--bg-proTheme) !important;
	font-family: "Montserrat", sans-serif;
	background-color: transparent !important;
	padding: 1px 15px !important;
	color: var(--bg-proTheme) !important;
	font-size: var(--size-13) !important;
	font-weight: 500 !important;
	width: fit-content;
	white-space: nowrap;
}
.pd-table {
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	background-color: #fcfcfc;
	border: 1px solid #8c8c8c12;
	position: relative;
	max-height: 300px;
	padding-inline: 25px;
}
.pd-overflow {
	max-height: 220px;
	overflow: auto;
}
.pd-overflow::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.pd-table .blue-bar {
	position: absolute;
	background-color: #20639b;
	height: 96%;
	width: 4px;
	border-radius: 4px;
	left: 3px;
	top: 2%;
}
.pd-table .pd-row {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #dbdbdb;
	padding-block: 10px;
}
.pd-row .one,
.pd-row .two,
.pd-row .three,
.pd-row .four {
	width: 24.5%;
}
.show-hist-pos {
	bottom: 17px;
}
.color-mainblue {
	color: #20639b !important;
	/* #20639b */
}
.scrollable-content {
	overflow-x: auto;
	white-space: nowrap;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
@media (max-width: 1028px) {
	.mobgap1 {
		gap: 0.25rem !important;
	}
	.mobgap3 {
		gap: 1rem !important;
	}
	.suspendcards .card {
		width: 299px;
		height: 211px;
	}
	.suspendcards .card-body {
		padding: 10px;
	}
	.align-items-unset-mob {
		align-items: unset !important;
	}
	.cancelint-cards {
		width: 299px;
		height: 115px;
		background: #ffffff;
		border: 1px solid rgba(140, 140, 140, 0.15);
		box-shadow: 0px 4px 5px 1px rgba(111, 111, 111, 0.17);
		border-radius: 8px;
		flex-shrink: 0;
		padding: 10px;
	}
	.ci-intid {
		padding: 2px 4px;
		background: #f6f9fb;
		border-radius: 4px;
		width: fit-content;
	}
	.color-727478 {
		color: #727478;
	}
	.color-627290 {
		color: #627290;
	}
	.mobrotate0 {
		transform: rotate(0deg) !important;
	}
}
</style>
